module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/social-report.faaf67b5.svg";